import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from 'shared/store';

export const mechanicDetailApiPost = createApi({
  reducerPath: 'mechanicDetailApiPost',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['AddStep', 'AddSku', 'DeleteSku', 'DeleteStep', 'ChangeStep'],
  endpoints: (builder) => ({
    // Дублирование из features для скрытия ошибки, потом убрать
    getMe: builder.query({
      query: () => ({
        url: '',
      }),
    }),
  }),
});
